import { render } from "./ContentMessage.vue?vue&type=template&id=547709a5&scoped=true"
import script from "./ContentMessage.vue?vue&type=script&lang=js"
export * from "./ContentMessage.vue?vue&type=script&lang=js"

import "./ContentMessage.vue?vue&type=style&index=0&id=547709a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547709a5"]])

export default __exports__